import { Helmet } from "react-helmet-async";

const DEFAULTS = {
    siteName: "Urban Oasis",
    baseUrl: "https://urbanoasis.ae/",
    baseImage: "https://urbanoasis.ae/",
    defaultImage: "https://urbanoasis.ae/image/dubai-palm-jumeirah-island-aerial-view.avif",
};

interface SEOProps {
    title?: string;
    description?: string;
    url?: string;
    image?: string;
    type?: string;
    noIndex?: boolean;
    keywords?: string;
    author?: string;
    schema?: Record<string, any> | null;
}

const SEO = ({
    title,
    description,
    url = "",
    image,
    type = "website",
    noIndex = false,
    keywords,
    author = "Urban Oasis",
    schema = null,
}: SEOProps) => {

    const fullUrl = `${DEFAULTS.baseUrl}${url}`;
    const metaTitle = title
        ? `${title} | ${DEFAULTS.siteName}`
        : DEFAULTS.siteName;

    const metaImage = image ? `${DEFAULTS.baseImage}${image}` : DEFAULTS.defaultImage;

    return (
        <Helmet>

            <title>{metaTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content={author} />
            <meta
                name="robots"
                content={noIndex ? "noindex,nofollow" : "index,follow"}
            />

            <link rel="canonical" href={fullUrl} />

            <meta property="og:type" content={type} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:site_name" content={DEFAULTS.siteName} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={metaImage} />

            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}

        </Helmet>
    );
};

export default SEO;